class PropertyLeaseHolders {
    items;
    constructor(data) {
        this.items = data.items;
    }
}
export default PropertyLeaseHolders;
